<template>
  <div class="Input form-group mb-4" :class="hasValidationErrorClass">
    <label v-if="label != null" class="Input--label form-label" :for="labelfor">{{ label }}
      <mb-tooltip v-if="info!=null" :title="info" :content="infotext" />
    </label>
    <template v-if="!readonly" class="relative" :class="rootClasses">
      <vue-typeahead-bootstrap backgroundVariant="light"
      :value="computedZipCodeCityValue" 
      :data="zipcodes" 
      :inputName="inputName"
      :serializer="item => item.value" 
      class="form-control typeahead-field"     
      @hit="onHit($event)" 
      @input="onInput($event)"
      v-typeahead-blur="handleBlur"
      v-typeahead-name="inputName" 
      :disabled="disabled">
      </vue-typeahead-bootstrap>
      <div v-if="hasErrors" class="invalid-feedback mt-2">
        <template v-for="(mess, i) in formattedMessage">
          {{ mess }}
          <br :key="i" v-if="(i + 1) < formattedMessage.length" />
        </template>
      </div>
    </template>
    <template v-else :class="rootClasses">
      <span :name="name" class="bold label">{{ newZipCodeCityValue }}</span>
    </template>
  </div>
</template>
<script>
import Service from "@/service/backend-api.js";

export default {
  name: "mb-plzort",
  components: {},
  inheritAttrs: false,
  props : {
    validator: Object,
    isStaticZipCityJson: { type: Boolean, default: false },
    message: Object,
    value: String,
    customClass: {
      type: String,
      default: ""
    },
    inputName: {
      type: String,
      default: "plzort"
    },      
    arrayIndex: { Number, default: -1},
    disabled: {Boolean, default: false},
    label: String,
    info: String,
    infotext: String, 
    labelfor: String,    
  },
  data() {
    return {
      maxItems: 100,
      readonly: false,
      zipcodes : [],
      selectedZipcodeCityObject : {},
      newZipCodeCityValue : '',
      errors: [],
      isValidSelection: { type: Boolean},
      eventType: ''
    };
  },
  created() {
    // console.log('plzort.vue CREATED invoked arrayIndex : '+this.arrayIndex+', value : '+this.value+ ', newZipCodeCityValue : '+this.newZipCodeCityValue);
  },
  mounted() {
    if(this.value != undefined && this.value != ''){
      this.newZipCodeCityValue = this.value;
      this.fetchZipCodeCity(this.newZipCodeCityValue);
    }
    // console.log('plzort.vue MOUNTED invoked arrayIndex : '+this.arrayIndex+', value : '+this.value+ ', newZipCodeCityValue : '+this.newZipCodeCityValue);
  },
  watch: {
    selectedZipcodeCityObject: {
      handler(newValue, oldValue){
        if(this.eventType !== ''){
          // console.log('plzort.vue INSIDE WATCH selectedZipcodeCityObject EVENT_TYPE : '+this.eventType);
          // console.dir(newValue);
          this.$emit("selectedZipcodeCityObject", this.selectedZipcodeCityObject);
        }
      },
      deep: true
    }
  },
  computed: {
    computedZipCodeCityValue() {
      // console.log('plzort.vue COMPUTED computedZipCodeCityValue eventType : '+this.eventType+', newZipCodeCityValue : '+ this.newZipCodeCityValue);
      // console.log('plzort.vue COMPUTED : '+(this.zipcodes != undefined));
      if(this.newZipCodeCityValue != null && this.newZipCodeCityValue !== '' && this.newZipCodeCityValue.length >= 2 && this.zipcodes != undefined && this.zipcodes.length > 0) {
        console.log('this.zipcodes.length = '+this.zipcodes.length);
        for (let i = 0;i < this.zipcodes.length;i++) {
          var zipCityValue = this.zipcodes[i].plz+" "+this.zipcodes[i].ort;
          // console.log('zipCityValue : '+zipCityValue);
          if(zipCityValue === this.newZipCodeCityValue){
            // console.log('COMPUTED : Match Found : '+zipCityValue);
            this.updateZipCodeCityObject(this.zipcodes[i], zipCityValue);
            return zipCityValue;
          }
        }
        // console.log('COMPUTED : No Match Found : '+this.eventType);      
        this.updateZipCodeCityObject(null, this.newZipCodeCityValue);
      }
      return this.newZipCodeCityValue;
    },
    formattedMessage() {
      let messages = [];
      if (Array.isArray(this.errors)) {
        this.errors.forEach(message => {
          if (typeof message === "string") {
            messages.push(message);
          } else {
            for (let key in message) {
              if (message[key]) {
                messages.push(key);
              }
            }
          }
        });
      } else {
        for (let key in this.errors) {
          if (this.errors[key]) {
            messages.push(key);
          }
        }
      }
      return messages.filter(m => {
        if (m) return m;
      });
    },
    hasValidationError() {
      // console.log('hasValidationError validator.$error: '+this.validator.$error);
      var isInvalidZipCodeCityValue = this.isValidZipcodeCity();
      // console.log('hasValidationError isInvalidZipCodeCityValue : '+isInvalidZipCodeCityValue);
      if ((this.eventType === 'Input' && this.newZipCodeCityValue.length >= 2) || (this.eventType === 'Blur' || this.eventType === 'Hit') || this.validator.$error) {
        if (this.validator.$error || this.validator.$serverError || isInvalidZipCodeCityValue) {
          // console.log('hasValidationError serverError : '+this.validator.$serverError+ ', error : '+this.validator.$error);
          // TODO Find proper error & display
          this.errors = [];
          if( this.validator.$serverError ){
            this.errors.push(this.message.serverError);
          } else {
            this.errors.push(this.message.default);
          }
          // console.log('hasValidationError this.errors : '+this.errors);
          return true;
        } else {
          this.errors = [];
          return false;
        }
      }
      return false;
    },
    hasValidationErrorClass() {
      // console.log('hasValidationErrorClass : ');
      return this.hasValidationError ? 'is-invalid' : '';
    },
    rootClasses() {
      return [
        this.iconPosition,
        this.size,
        {
          "is-expanded": this.expanded,
          "is-loading": this.loading,
          "is-clearfix": !this.hasMessage
        }
      ];
    },
    inputClasses() {
      return [this.statusType, this.size, { "is-rounded": this.rounded }];
    },
    hasErrors() {
      // console.log('hasErrors : '+this.errors);
      return this.errors && this.errors.length > 0;
    },
    isSuccess() {
      if (this.validator != null) {
        // console.log('isSuccess serverError : '+this.validator.$serverError+', dirty :'+this.validator.$dirty+ ', error : '+this.validator.$error);
        if (this.validator.$serverError) {
          return false;
        } else if (this.validator.$dirty) {
          return !this.validator.$error;
        } else {
          return false;
        }
      }
      return false;
    }
  },
  methods: {
    onInput(event) {
      console.log('onInput eventValue : '+event +', value : '+this.value+', newZipCodeCityValue : '+this.newZipCodeCityValue);
      this.eventType='Input';
      this.fetchZipCodeCity(event);
    },
    onHit(event) {
      //console.log('onHit eventValue : '+event.value+', plz : '+event.plz+', ort : '+event.ort);
      this.eventType='Hit';
      this.newZipCodeCityValue = event.plz+ " "+event.ort;
      this.triggerValidator();    
    },
    handleBlur(event) {
       console.log('handleBlur eventValue : '+event.target.value);
      console.log('handleBlur trigerred - event value:', event.target.value);
      this.eventType='Blur';
      this.newZipCodeCityValue = event.target.value;
      this.triggerValidator();
    },
    triggerValidator() {
      if (this.validator) {
        this.$nextTick(() => {
          this.validator.$touch();
        });
      }
    },
    fetchZipCodeCity(newValue) {
     if (newValue === '' && newValue.length < 2) {
       this.newZipCodeCityValue = newValue;
     } else if (newValue.length >= 2) {
        var queryString='?zipCodeCity='+newValue+'&isStaticZipCityJson='+this.isStaticZipCityJson;
        Service.loadZipCodes(queryString).then(({ data }) => {
          console.log('After Response returned from backend loadZipCodes : '+data.length);
          //console.dir(data);
          // console.log('fetchZipCodeCity EVENT_TYPE : '+this.eventType+', newValue : '+newValue);
          if(this.eventType!=='Hit') {
            this.zipcodes = data;
          }
          //this.newZipCodeCityValue = newValue;
        }).catch(error => {
          // console.log(error.response.data);
        });
      }
    },
    updateZipCodeCityObject(object, value) {
      // console.log('updateZipCodeCityObject : object' + object + ' object isNotNull : '+(object != null))
      var zipCodeCityObject = {};
      if(object != null) {
        // console.dir(object);
        if(object.kanton === undefined && object.canton != null && object.canton != ''){
          zipCodeCityObject.kanton=object.canton;
        } else {
          zipCodeCityObject.kanton=object.kanton;
        }
        zipCodeCityObject.value=object.plz+" "+object.ort;
        zipCodeCityObject.canton=this.getCantonKey(zipCodeCityObject.kanton);
        zipCodeCityObject.plz=object.plz;
        zipCodeCityObject.ort=object.ort;
        zipCodeCityObject.tokens=object.tokens;
      } else {
        zipCodeCityObject.value=value;
        zipCodeCityObject.plz='';
        zipCodeCityObject.ort='';
        zipCodeCityObject.kanton='';
        zipCodeCityObject.canton='';
      }
      zipCodeCityObject.arrayIndex=this.arrayIndex;
      this.selectedZipcodeCityObject = zipCodeCityObject;
      // console.dir(this.selectedZipcodeCityObject);
      //this.newZipCodeCityValue=this.selectedZipcodeCityObject.value;
      //this.value=this.selectedZipcodeCityObject.value;
    },
    getCantonKey(kanton) {
        var kantonArray = {
                "FL" : '0',
                "ZH" : '1',
                "BE" : '2',
                "LU" : '3',
                "UR" : '4',
                "SZ" : '5',
                "OW" : '6',
                "NW" : '7',
                "GL" : '8',
                "ZG" : '9',
                "FR" : '10',
                "SO" : '11',
                "BS" : '12',
                "BL" : '13',
                "SH" : '14',
                "AR" : '15',
                "AI" : '16',
                "SG" : '17',
                "GR" : '18',
                "AG" : '19',
                "TG" : '20',
                "TI" : '21',
                "VD" : '22',
                "VS" : '23',
                "NE" : '24',
                "GE" : '25',
                "JU" : '26'
              };
              var cantonKey = kantonArray[kanton];
              // console.log('cantonKey : '+cantonKey);
              return cantonKey;
    },
    isValidZipcodeCity() {
      if(this.newZipCodeCityValue != null && this.newZipCodeCityValue !== '' && this.zipcodes != undefined && this.zipcodes.length > 0) {
        for (let i = 0;i < this.zipcodes.length;i++) {
          var zipCityValue = this.zipcodes[i].plz+" "+this.zipcodes[i].ort;
          // console.log("zipCityValue : {}", zipCityValue);
          if(zipCityValue === this.newZipCodeCityValue){
            // console.log('isValidZipcodeCity : MATCH_FOUND : '+this.newZipCodeCityValue);
            return false;
          }
        }
      }
      // console.log('isValidZipcodeCity : NO_MATCH_FOUND : '+this.newZipCodeCityValue);
      return true;
    },
  },
  directives: {
    'typeahead-blur' : {
      bind: function (el, binding, vnode) {
        // console.log('--------------------el------------------',el.getElementsByTagName('input'));
        el.addEventListener('blur', (event) => {
          if(event.target.value != undefined) {
            // console.log('typeahead-blur trigerred - event value:', event.target.value);
            vnode.context[binding.expression](event);
          }
        }, true);
      }
    },
    'typeahead-name' : {
      bind: function (el, binding, vnode) {
        if( el &&  el.getElementsByTagName('input') ) {
          const inputName = el.getElementsByTagName('input')[0];
          if( inputName && binding ) {
             inputName.setAttribute('id',binding.value);
          }
        }
      },   
    }    
  }
}  
</script>
<style scoped>
.invalid .input.typeahead-field {
	outline: 1px solid #d1374d;
	border: 0;
}
</style>
